import i18n from '../i18n';

const registeredNamespaces = new Set<string>();
const listeners = new Set<(namespace: string) => void>();

export const getRegisteredRecruiterNamespaces = (): readonly string[] => [
  ...registeredNamespaces,
];

export const onRecruiterNamespaceRegistered = (
  listener: (namespace: string) => void
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Registers a recruiter namespace's English bundle and returns its name.
 * Namespace modules export the return value as their `*_NS` constant, so any
 * component that names the namespace has also registered its English text.
 */
export const registerRecruiterNamespace = <Namespace extends string>(
  namespace: Namespace,
  english: Record<string, string>
): Namespace => {
  if (!i18n.hasResourceBundle('en', namespace)) {
    // English JSON modules are never mutated, so i18next need not copy them.
    i18n.addResourceBundle('en', namespace, english, false, false, {
      skipCopy: true,
    });
  }
  if (!registeredNamespaces.has(namespace)) {
    registeredNamespaces.add(namespace);
    for (const listener of listeners) listener(namespace);
  }
  return namespace;
};
